import { getTypeColor, getTypeLabel } from "./constants";

export function TypeBadge({ type }) {
  if (!type) return <span className="text-[#64748B]">-</span>;
  return (
    <span
      className="px-2 py-1 text-xs uppercase tracking-wide font-bold text-white"
      style={{ backgroundColor: getTypeColor(type) }}
      data-testid={`type-badge-${type}`}
    >
      {getTypeLabel(type)}
    </span>
  );
}
